import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  apps: [],
};

const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState,
  reducers: {
    myApplicationList: (state, action) => {
      state.apps = action.payload;
    },
  },
});

export const { myApplicationList } = applicationSlice.actions;
export default applicationSlice.reducer;
